<template>
  <div class="loading">
    <div class="loading-icon"></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.loading {
  position: relative;
  min-height: 250px;

  .loading-icon {
    background: #fff;
    display: block;
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 100;
  }

  .loading-icon:after {
    animation: splash-spinner 1.2s linear infinite;
    border: 5px solid #0061d4;
    border-radius: 50%;
    border-top-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    content: "";
    display: block;
    height: 40px;
    left: 50%;
    margin-left: -20px;
    position: absolute;
    top: 50%;
    width: 40px;
  }
}

@keyframes splash-spinner {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
